import { graphql } from '../../gql';

export const GetReportConfig = graphql(`
  query GetReportConfig {
    reports_validation {
      report_validation {
        id
        report_type
        label
        description
        sample_link
        category
        main_entity {
          selection_list
          limit
          required
          label
          description
        }
        comparison_entities {
          selection_list
          limit
          required
          label
          description
        }
        filters {
          selection_list
          limit
          required
          label
          description
        }
      }
    }
  }
`);
